import React from "react";
import LeadingIcon from "../../assets/images/Leading.svg";
import { gtmPush } from "../../analytics/useGtmPageview.tsx";

const CustomEditButton = ({
  onClick,
  text,
  icon = LeadingIcon,
  type = "button",
}) => {
  const handleClick = (e) => {
    // ✅ Push event to GTM
    gtmPush("button_click", {
      elementId: "custom-button",
      button_text: text,
      page_path: window.location.pathname + window.location.search,
    });

    // ✅ Call the parent’s onClick if provided
    if (onClick) {
      onClick(e);
    }
  };
  return (
    <button
      className="step-btn edit-btn btn-spacer"
      onClick={handleClick}
      type={type}
    >
      <img src={icon} alt="" />
      {text}
    </button>
  );
};

export default CustomEditButton;
